import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import axios from 'axios'
import { config } from '../config';
import { authenticator } from './Authenticator';

class NewPatientFormsLinkGenerator {

  public async generate(chartNumber: string, viewer: 'patient' | 'dentist'): Promise<string> {
    const token = await authenticator.getToken()
    const response = await axios.post(`${config.serverUrl}/forms/new-patient-forms`, {
      chartNumber, 
      viewer
    }, { headers: { Authorization: `Bearer ${token}` }})
    return response.data.formUrl.id
  }

}

export const newPatientFormsLinkGenerator = new NewPatientFormsLinkGenerator()